import { createApp } from 'vue';
import AssetTokenInfo from './components/AssetTokenInfo.vue'; // Adjust path if necessary
import axios from 'axios'; // Keep axios import if AssetTokenInfo uses it directly

// --- Initialization ---
document.addEventListener('DOMContentLoaded', () => {
    // Select the specific divs intended as mount points
    const mountPoints = document.querySelectorAll('.asset-dynamic-content[data-asset-json]');

    mountPoints.forEach(element => {
        try {
            const assetData = JSON.parse(element.dataset.assetJson);
            if (assetData && assetData.address) {
                // Create and mount a new Vue app instance for each component
                // Pass the parsed asset data as a prop
                createApp(AssetTokenInfo, { asset: assetData }).mount(element);
            } else {
                console.warn('Asset data missing or invalid for element:', element);
                // Optionally display an error message within the element
                element.innerHTML = '<div class="text-danger small text-center py-3">Failed to load component data.</div>';
            }
        } catch (e) {
            console.error('Error parsing asset JSON or mounting component:', e, element.dataset.assetJson);
             // Optionally display an error message within the element
             element.innerHTML = '<div class="text-danger small text-center py-3">Error loading component.</div>';
        }
    });
});

// No need to export anything unless called manually elsewhere
